















import { createComponent, ref } from "@vue/composition-api";

interface Props {
  action: (...data: any) => Promise<any>;
  successMessage: string;
  validator: () => any;
}

export default createComponent<Props>({
  components: {},
  props: {
    action: { required: true },
    successMessage: { default: "" },
    validator: { default: () => () => {} },
  },
  inheritAttrs: false,
  setup(props, ctx) {
    const inProgress = ref(false);

    async function execute() {
      if (inProgress.value) return;
      await props.validator();
      inProgress.value = true;

      try {
        const response = await props.action();
        ctx.emit("response", response);
        if (props.successMessage)
          ctx.root.$notify.success(props.successMessage);
      } finally {
        inProgress.value = false;
      }
    }

    return { execute, inProgress };
  },
});
